module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_7016.0f49ad79.png";